"use strict";

angular
    .module("licensure.internal", [
        // angular modules
        "ui.router",
        "LocalStorageModule",
        "ui.bootstrap",
        "ngAnimate",
        "as.sortable",
        "ngSignaturePad",
        "ngFileUpload",
        "ngIdle",

        // imagetrend modules
        "imagetrend.components",
        "licensure.helpers",
        "licensure.services",

        // internal modules
        "internal.licenses",
        "internal.inspections",
        "internal.applications",
        "internal.investigations",
        "internal.users",
        "internal.services",
        "internal.vehicles",
        "internal.trainings",
        "internal.admin",
        "internal.setup",
        "internal.education",
        "internal.exams",
        "internal.accountDashboard"
    ])
    .config([
        "$stateProvider",
        //"$urlRouterProvider",
        "$httpProvider",
        "localStorageServiceProvider",
        "$locationProvider",
        function(
            $stateProvider,
            //$urlRouterProvider,
            $httpProvider,
            localStorageServiceProvider,
            $locationProvider
        ) {
            $locationProvider.hashPrefix(''); // otherwise starts as '!'

            $httpProvider.interceptors.push("ApiIntercepter");
            if (!$httpProvider.defaults.headers.get) {
                $httpProvider.defaults.headers.get = {};
            }
            $httpProvider.defaults.headers.get["Cache-Control"] = "no-cache";
            $httpProvider.defaults.headers.get["Pragma"] = "no-cache";
            //$httpProvider.defaults.transformResponse.push(function (responseData) {
            //    convertDateStringsToDates(responseData);
            //    return responseData;
            //})
            //$urlRouterProvider.otherwise('/licenses');
            localStorageServiceProvider.setPrefix("licensure");

            $stateProvider
                // internal routings
                .state("internal", {
                    abstract: true,
                    templateUrl: paths.app + "layouts/internal.html",
                    data: {
                        isPortal: false,
                        loginRequired: false
                    },
                    resolve: {
                        userAccount: [
                            "$state",
                            "$rootScope",
                            "Account",
                            function($state, $rootScope, Account) {
                                if ($rootScope.userAccount == null) {
                                    $rootScope.loadingUserAccount = true;
                                    $rootScope.$state.current = this.self;
                                    return Account.get({ portal: false }).then(
                                        function (account) {
                                            $rootScope.userAccount = account;
                                            $rootScope.loadingUserAccount = false;
                                        }
                                    );
                                } else {
                                    return $rootScope.userAccount;
                                }
                            }
                        ],

                        enterprise: [
                            "$state",
                            "$rootScope",
                            "Enterprise",
                            "IntegrationLocation",
                            function ($state, $rootScope, Enterprise, IntegrationLocation) {
                                if ($rootScope.enterprise == null) {
                                    $rootScope.loadingEnterprise = true;
                                    $rootScope.$state.current = this.self;

                                    return Enterprise.getLess().then(
                                        function (enterprise) {
                                            $rootScope.enterprise = enterprise;
                                            $rootScope.loadingEnterprise = false;

                                            IntegrationLocation.getLess(enterprise.id).then(function (data) {
                                                $rootScope.locationIntegration = data;
                                            });
                                        }
                                    );
                                } else {
                                    return $rootScope.enterprise;
                                }
                            }
                        ]
                    }
                })
                .state("internal.licensing", {
                    abstract: true,
                    templateUrl: paths.app + "layouts/licensing.html"
                })
                .state("internal.licensing.denied", {
                    url: "/licensing/denied",
                    templateUrl: paths.app + "layouts/denied.html"
                })
                .state("internal.exams.denied", {
                    url: "/exams/denied",
                    templateUrl: paths.app + "layouts/denied.html"
                })
                .state("internal.education.denied", {
                    url: "/education/denied",
                    templateUrl: paths.app + "layouts/denied.html"
                })
                .state("internal.education", {
                    abstract: true,
                    templateUrl: paths.app + "layouts/education.html"
                })
                .state("internal.inspecting", {
                    abstract: true,
                    templateUrl: paths.app + "layouts/inspecting.html"
                })
                .state("internal.inspecting.denied", {
                    url: "/inspecting/denied",
                    templateUrl: paths.app + "layouts/denied.html"
                })
                .state("internal.admin", {
                    abstract: true,
                    templateUrl: paths.app + "layouts/admin.html"
                })
                .state("internal.admin.denied", {
                    url: "/admin/denied",
                    templateUrl: paths.app + "layouts/denied.html"
                })
                .state("internal.setup", {
                    abstract: true,
                    templateUrl: paths.app + "layouts/licensing.html"
                })
                .state("internal.accountDashboard.account", {
                    abstract: true,
                    templateUrl: paths.app + "layouts/licensing.html"
                })
                .state("internal.setup.denied", {
                    url: "/setup/denied",
                    templateUrl: paths.app + "layouts/denied.html"
                })
                .state("internalNH", {
                    abstract: true,
                    templateUrl: paths.app + "layouts/internalNH.html",
                    data: {
                        isPortal: false
                    },
                    resolve: {
                        userAccount: [
                            "$state",
                            "$rootScope",
                            "Account",
                            function($state, $rootScope, Account) {
                                $rootScope.noHeader = true;
                                if ($rootScope.userAccount == null) {
                                    $rootScope.loadingUserAccount = true;
                                    $rootScope.$state.current = this.self;
                                    return Account.get().then(function(
                                        account
                                    ) {
                                        $rootScope.userAccount = account;
                                        $rootScope.loadingUserAccount = false;
                                    });
                                } else {
                                    return $rootScope.userAccount;
                                }
                            }
                        ],

                        enterprise: [
                            "$state",
                            "$rootScope",
                            "Enterprise",
                            "IntegrationLocation",
                            function ($state, $rootScope, Enterprise, IntegrationLocation) {
                                $rootScope.noHeader = true;

                                if ($rootScope.enterprise == null) {
                                    $rootScope.loadingEnterprise = true;
                                    $rootScope.$state.current = this.self;
                                    return Enterprise.getLess().then(function (enterprise) {
                                        $rootScope.enterprise = enterprise;
                                        $rootScope.loadingEnterprise = false;

                                        IntegrationLocation.getLess(enterprise.id).then(function (data) {
                                            $rootScope.locationIntegration = data;
                                        });
                                    });
                                } else {
                                    return $rootScope.enterprise;
                                }
                            }
                        ]
                    }
                });
        }
    ])
    .run([
        "$rootScope",
        "$state",
        "localStorageService",
        "HttpPendingRequests",
        "Session",
        "Utils",
        "Enterprise",
        function ($rootScope, $state, localStorageService, HttpPendingRequests, Session, Utils, Enterprise) {
            $rootScope.now = new Date();
            $rootScope.$state = $state;
            const nonAuthStates = ['internal.login', 'internal.forgotPassword', 'internal.twoFactorAuthentication', 'internal.changePassword', 'internal.oidcLogin', 'internal.oidcCallback'];

            const ckEditorStates = ['internal.education.configuration.mergetemplate.details', 'internal.education.configuration.pdfcertificate', 'internal.education.course.sendcorrespondence', 'internal.education.course.note',
                'internal.exams.administrative.form.builder', 'internal.exams.administrative.skill', 'internal.exams.administrative.skills', 'internal.exams.administrative.correspondence',
                'internal.exams.session.correspondence', 'internal.inspecting.inspection.correspondence', 'internal.inspecting.resource.checklists', 'internal.inspecting.resource.checklist.form',
                'internal.inspecting.resource.checklist.layout', 'internal.licensing.investigation.correspondence', 'internal.licensing.investigation.note', 'internal.licensing.investigation.notes',
                'internal.licensing.license.form.builder'];

            function loadCKEditorIfNecessary(stateName) {
                if (ckEditorStates.includes(stateName)) {
                    var head = document.getElementsByTagName('head')[0];
                    var script = 'licensure/include/ckeditor/ckeditor.js';

                    // Can be called twice, ensures we don't add the same script twice
                    if (!head.querySelector('script[src="' + script + '"]')) {
                        var ckEditorScript = document.createElement('script');
                        ckEditorScript.type = 'text/javascript';
                        ckEditorScript.src = script + '?v=4.22.1'; // Update version as we Update CKEditor
                        head.appendChild(ckEditorScript);
                    }
                }
            }

            document.addEventListener("visibilitychange", function () {
                if (document.visibilityState === 'visible' && !nonAuthStates.includes($state.current.name)) {
                    //Check their session in case the user closes their computer, reopens and their session is expired
                    Session.IsSessionAlive().then(function (session) {
                        //If session is expired, log them out
                        if (!session) {
                            Utils.DeleteSessionCookie(false);
                            Session.expireSession(false);
                            localStorageService.remove('internalAuthorizationData');
                            $rootScope.userAccount = null;
                            $state.go("internal.login");
                        }
                    });
                }
            });
            $rootScope.$on("$stateChangeStart", function(
                event,
                toState,
                toParams,
                fromState,
                fromParams
            ) {
                if (toState.resolve) {
                    $rootScope.resolving = true;

                    $rootScope.authenticatedPage = !nonAuthStates.includes(toState.name);
                }
                loadCKEditorIfNecessary(toState.name);
            });
            $rootScope.$on("$stateChangeSuccess", function(
                ev,
                to,
                toParams,
                from,
                fromParams
            ) {
                $rootScope.$state = $state;
                $rootScope.$state.from = from;
                $rootScope.$state.from.params = fromParams;
                Session.checkIn();
                if (to.resolve) {
                    $rootScope.resolving = false;
                }
                loadCKEditorIfNecessary(to.name);
                //if (to.name != from.name) {
                //    HttpPendingRequests.cancelAll($rootScope.$state);
                //}

                // sets auth enterprise when switching from CF to .NET or non-auth to auth
                if ($rootScope.userAccount !== null && from.name === '' && !nonAuthStates.includes(to.name)) {
                    Enterprise.get().then(function (enterprise) {
                        if (enterprise != null) {
                            $rootScope.enterprise = enterprise;
                        }
                    });
                }
            });
            localStorageService.remove("internalAuthorizationData");
        }
    ]);
